import React from 'react';
import { JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib';
import {
    Text,
    View,
    StyleSheet,
    TouchableOpacity
} from 'react-native';
import { pt } from '../../../../components/utiles';

const ProvinceItem = (props) => {
    return (
        <JDTouchableWithoutFeedback onPress={props.onSelect}>
            <View style={[styles.provinceItem, props.isSelected ? styles.provinceItemSelected : null]}>
                <View style={[styles.provinceSelectMark, !props.isSelected ? styles.provinceSelectMarkHidden : null]} />
                <Text style={styles.itemTitle}>{props.title}</Text>
            </View>
        </JDTouchableWithoutFeedback>

    );
};

export default ProvinceItem;

const styles = StyleSheet.create({
    provinceItem: {
        width: pt(170),
        height: pt(88),
        flexDirection: 'row',
        backgroundColor: '#F6F6F6',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    provinceSelectMark: {
        width: pt(8),
        height: pt(28),
        backgroundColor: '#FA2C19',
        marginLeft: pt(4),
        marginRight: pt(20)
    },
    provinceItemSelected: {
        backgroundColor: '#FFF'
    },
    provinceSelectMarkHidden: {
        backgroundColor: 'transparent'
    },
    itemTitle: {
        fontSize: pt(26),
        color: '#262626',
        lineHeight: pt(32) }
});
